import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=00972470&scoped=true&"
import script from "./ContentFooter.vue?vue&type=script&lang=js&"
export * from "./ContentFooter.vue?vue&type=script&lang=js&"
import style1 from "./ContentFooter.vue?vue&type=style&index=1&id=00972470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00972470",
  null
  
)

export default component.exports